import useAxios, {configure} from 'axios-hooks';
import axios from '../service/api';

configure({axios});

const useGet = (url, manual = true, config = {target: 'alf'}) => {
  const [{data, loading, error}, execute] = useAxios({...config, url, method: 'GET'}, {manual});
  return {response: data, loading, error, execute};
};

const usePut = (url, manual = true, body = {}, config = {target: 'alf'}) => {
  const [{data, loading, error}, execute] = useAxios({...config, data: body, url, method: 'PUT'}, {manual});
  return {response: data, loading, error, execute};
};

const usePost = (url, manual = true, body = {}, config = {target: 'alf'}) => {
  const [{data, loading, error}, execute] = useAxios({...config, data: body, url, method: 'POST'}, {manual});
  return {response: data, loading, error, execute};
};

const useDelete = (url, manual = true, body = {}, config = {target: 'alf'}) => {
  const [{data, loading, error}, execute] = useAxios({...config, data: body, url, method: 'DELETE'}, {manual});
  return {response: data, loading, error, execute};
};

export const apiHooks = {
  useGet,
  usePut,
  usePost,
  useDelete,
};
